<template>
  <div id="beautyCenterDiv" class="wrap">
    <el-dialog :visible.sync="beautyCenterVisible"
      :before-close="beauty_center_dialog_close" v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
      element-loading-text="加载中" element-loading-spinner="el-icon-loading"
      append-to-body width="520px">
      <div class="beauty-content">
        <div class="preview-section">
          <div class="preview-row">
            <div class="preview-col">
              <div class="preview-label">当前形象</div>
              <div class="preview-box">
                <div class="preview-inner" v-if="initialHeader.faceUrl">
                  <div class="layer" :style="{ backgroundImage: 'url(' + ossPath + initialHeader.faceUrl + ')' }"></div>
                  <div class="layer" :style="{ backgroundImage: 'url(' + ossPath + initialHeader.eyeUrl + ')' }"></div>
                  <div class="layer" :style="{ backgroundImage: 'url(' + ossPath + initialHeader.mouthUrl + ')' }"></div>
                  <div class="layer" :style="{ backgroundImage: 'url(' + ossPath + initialHeader.hairUrl + ')' }"></div>
                </div>
                <div class="preview-inner" v-else>
                  <div class="no-header">暂无</div>
                </div>
              </div>
            </div>
            <div class="preview-col">
              <div class="preview-label">目标形象</div>
              <div class="preview-box">
                <div class="preview-inner" v-if="selectedHeader.faceUrl">
                  <div class="layer" :style="{ backgroundImage: 'url(' + ossPath + selectedHeader.faceUrl + ')' }"></div>
                  <div class="layer" :style="{ backgroundImage: 'url(' + ossPath + selectedHeader.eyeUrl + ')' }"></div>
                  <div class="layer" :style="{ backgroundImage: 'url(' + ossPath + selectedHeader.mouthUrl + ')' }"></div>
                  <div class="layer" :style="{ backgroundImage: 'url(' + ossPath + selectedHeader.hairUrl + ')' }"></div>
                </div>
                <div class="preview-inner" v-else>
                  <div class="no-header">暂无</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="selector-section" v-if="headerTypes.face.length > 0">
          <div class="type-group" v-for="(group, typeKey) in headerTypes" :key="typeKey">
            <div class="type-label">{{ typeLabels[typeKey] }}</div>
            <div class="type-items">
              <div v-for="item in group" :key="item.facialId"
                class="type-item"
                :class="{ active: isSelected(typeKey, item.facialId) }"
                @click="selectType(typeKey, item)">
                <img :src="ossPath + item.picUrl" :title="item.facialId">
              </div>
            </div>
          </div>
        </div>

        <div class="action-section">
          <el-button type="warning" plain size="mini" @click="randomPreview">随机预览</el-button>
          <el-button type="primary" plain size="mini" @click="saveHeader">保存形象</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRequest } from '../../utils/api'
import { postRequest } from '../../utils/api'
import Message from 'element-ui/lib/message'
export default {
  name: 'beautyCenter',
  props: {
    beautyCenterVisible: {
      type: Boolean,
      default: false
    },
    fantasyUserBO: Object
  },
  data() {
    return {
      fantasyUserHeader: {},
      initialHeader: {
        faceId: '',
        mouthId: '',
        eyeId: '',
        hairId: '',
        faceUrl: '',
        mouthUrl: '',
        eyeUrl: '',
        hairUrl: ''
      },
      headerTypeList: [],
      changeHeaderCost: 100000,
      headerTypes: {
        face: [],
        mouth: [],
        eye: [],
        hair: []
      },
      selectedHeader: {
        faceId: '',
        mouthId: '',
        eyeId: '',
        hairId: '',
        faceUrl: '',
        mouthUrl: '',
        eyeUrl: '',
        hairUrl: ''
      },
      loading: false,
      typeLabels: {
        face: '脸型',
        eye: '眼睛',
        mouth: '嘴巴',
        hair: '发型'
      },
      facialTypeMap: {
        '01': 'face',
        '02': 'mouth',
        '03': 'hair',
        '04': 'eye'
      }
    }
  },
  watch: {
    beautyCenterVisible: {
      handler(newVal) {
        if (newVal === true) {
          this.loadData()
        }
      }
    }
  },
  mounted: function () {
    if (this.beautyCenterVisible) {
      this.loadData()
    }
  },
  methods: {
    loadData() {
      this.loading = true
      Promise.all([
        this.fetchUserHeader(),
        this.fetchHeaderTypes()
      ]).finally(() => {
        this.loading = false
      })
    },
    fetchUserHeader() {
      return getRequest('/user/userHeader/getUserHeaderInfo', {
        userId: this.fantasyUserBO.id
      }).then(resp => {
        if (resp.status == 200) {
          var respData = resp.data
          if (200 == respData.status && null != respData.data) {
        this.fantasyUserHeader = respData.data
        var header = {
          faceId: respData.data.faceId || '',
          mouthId: respData.data.mouthId || '',
          eyeId: respData.data.eyeId || '',
          hairId: respData.data.hairId || '',
          faceUrl: respData.data.faceUrl || '',
          mouthUrl: respData.data.mouthUrl || '',
          eyeUrl: respData.data.eyeUrl || '',
          hairUrl: respData.data.hairUrl || ''
        }
        this.initialHeader = { ...header }
        this.selectedHeader = { ...header }
          }
        }
      }, resp => {
        Message.error('查询玩家形象异常')
      })
    },
    fetchHeaderTypes() {
      return getRequest('/user/userHeader/listHeaderType', {}).then(resp => {
        if (resp.status == 200) {
          var respData = resp.data
          if (200 == respData.status && null != respData.data) {
            // 后端下发 {list, changeHeaderCost}（六章①），前端不再硬编码
            this.headerTypeList = respData.data.list || respData.data
            if (respData.data.changeHeaderCost != null) {
              this.changeHeaderCost = respData.data.changeHeaderCost
            }
            this.groupHeaderTypes()
          }
        }
      }, resp => {
        Message.error('获取五官类型异常')
      })
    },
    groupHeaderTypes() {
      var groups = { face: [], mouth: [], eye: [], hair: [] }
      for (var i = 0; i < this.headerTypeList.length; i++) {
        var item = this.headerTypeList[i]
        var key = this.facialTypeMap[item.facialType]
        if (key) {
          groups[key].push(item)
        }
      }
      this.headerTypes = groups
    },
    isSelected(typeKey, facialId) {
      var mapKey = typeKey + 'Id'
      return this.selectedHeader[mapKey] === facialId
    },
    selectType(typeKey, item) {
      this.selectedHeader[typeKey + 'Id'] = item.facialId
      this.selectedHeader[typeKey + 'Url'] = item.picUrl
    },
    randomPreview() {
      var keys = ['face', 'eye', 'mouth', 'hair']
      for (var i = 0; i < keys.length; i++) {
        var group = this.headerTypes[keys[i]]
        if (group.length > 0) {
          var randomIndex = Math.floor(Math.random() * group.length)
          var item = group[randomIndex]
          this.selectedHeader[keys[i] + 'Id'] = item.facialId
          this.selectedHeader[keys[i] + 'Url'] = item.picUrl
        }
      }
    },
    saveHeader() {
      if (!this.selectedHeader.faceId || !this.selectedHeader.mouthId ||
          !this.selectedHeader.eyeId || !this.selectedHeader.hairId) {
        Message.warning('请选择完整的五官')
        return
      }
      var _this = this
      this.$confirm('请注意，更换形象需支付整容费' + this.changeHeaderCost + '，成功后将从您的钱包中扣除相应费用。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.loading = true
        postRequest('/user/userHeader/saveHeader', {
          faceId: _this.selectedHeader.faceId,
          mouthId: _this.selectedHeader.mouthId,
          eyeId: _this.selectedHeader.eyeId,
          hairId: _this.selectedHeader.hairId
        }).then(resp => {
          _this.loading = false
          if (resp.status == 200) {
            var respData = resp.data
            if (200 == respData.status) {
              Message.success('形象保存成功')
              _this.fantasyUserHeader = respData.data
              _this.$store.commit('user/SET_USER_HEADER', respData.data)
              // 整容扣费后刷新用户详情，否则钱包金额滞留旧值（2026-10-03 与学习同步修复）
              this.$store.dispatch('user/fetchUserDetail')
            } else {
              Message.error(respData.message)
            }
          } else {
            Message.error('用户非法⊙﹏⊙∥!')
          }
        }, resp => {
          _this.loading = false
          Message.error('用户非法⊙﹏⊙∥!')
        })
      })
    },
    beauty_center_dialog_close() {
      this.$emit('beauty_center_dialog_close')
    }
  },
  beforeDestroy: function () {
  }
}
</script>

<style scoped>
.wrap {
  margin: auto;
  text-align: center;
}
.beauty-content {
  max-width: 480px;
  margin: 0 auto;
}
.preview-section {
  margin-bottom: 16px;
}
.preview-row {
  display: flex;
  justify-content: center;
  gap: 24px;
}
.preview-col {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.preview-label {
  font-size: 14px;
  font-weight: bold;
  color: #ff0000;
  margin-bottom: 8px;
}
.preview-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.preview-inner {
  width: 96px;
  height: 120px;
  position: relative;
}
.preview-inner .layer {
  width: 96px;
  height: 120px;
  position: absolute;
  top: 0;
  left: 0;
  background-size: 96px 120px;
  background-repeat: no-repeat;
}
.no-header {
  width: 96px;
  height: 120px;
  line-height: 120px;
  background: #f0f0f0;
  color: #999;
  font-size: 13px;
}
.selector-section {
  text-align: left;
  margin-bottom: 12px;
}
.type-group {
  margin-bottom: 10px;
}
.type-label {
  font-size: 13px;
  font-weight: bold;
  color: #333;
  margin-bottom: 4px;
  padding-left: 4px;
}
.type-items {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.type-item {
  width: 48px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  background: #fafaf5;
  transition: border-color 0.2s;
}
.type-item:hover {
  border-color: #72b653;
}
.type-item.active {
  border-color: #ff6600;
  background: #fff3e0;
}
.type-item img {
  width: 40px;
  height: 50px;
}
.action-section {
  text-align: center;
  margin-top: 12px;
}
.action-section .el-button {
  margin: 0 8px;
}

@media (max-width: 768px) {
  .preview-row {
    gap: 12px;
  }
  .preview-inner {
    width: 72px;
    height: 90px;
  }
  .preview-inner .layer {
    width: 72px;
    height: 90px;
    background-size: 72px 90px;
  }
  .no-header {
    width: 72px;
    height: 90px;
    line-height: 90px;
    font-size: 11px;
  }
  .type-item {
    width: 40px;
    height: 50px;
  }
  .type-item img {
    width: 32px;
    height: 40px;
  }
}
</style>
